import { Route } from 'react-router-dom';
import { potentielsParrainagesSchema } from './potentielsParrainages';
import Main from '@app/main/tables/Main';
import PotentielsParrainagesDetailsEnhanced from './PotentielsParrainagesDetailsEnhanced';

/**
 * Routes configurées pour le module PotentielsParrainages
 */
const PotentielsParrainagesRoutes = [
    // Route de liste (principale)
    <Route
        key="potentiels-parrainages-list"
        path="potentielsParrainages"
        element={
            <Main
                key="potentiels-parrainages-main"
                pageConfig={potentielsParrainagesSchema}
            />
        }
    />,

    // Route pour les détails d'un potentiel parrainage
    <Route
        key="potentiels-parrainages-details"
        path="potentielsParrainages/:id/details"
        element={<PotentielsParrainagesDetailsEnhanced />}
    />,
];

export default PotentielsParrainagesRoutes;
